let publicImagesPath = './assets/images'

export const images = {
  audiometriaSemTexto: `${publicImagesPath}/audiometria-sem-texto.webp`,
  background: `${publicImagesPath}/bg.webp`,
  ceo: `${publicImagesPath}/ceo.webp`,
  dimension: `${publicImagesPath}/dimension.webp`,
  eletrocardio: `${publicImagesPath}/eletrocardio-sem-texto.webp`,
  eletroencefalograma: `${publicImagesPath}/eletroencefalograma-sem-texto.webp`,
  espirometria: `${publicImagesPath}/espirometria.webp`,
  footerBg: `${publicImagesPath}/footer-bg.webp`,
  laboratorios: `${publicImagesPath}/laboratorio-sem-texto.webp`,
  novaAmerica: `${publicImagesPath}/nova-america.webp`,
  raioX: `${publicImagesPath}/raio-x.webp`,
  uruguaiana: `${publicImagesPath}/uruguaiana.webp`,
  visualSemTexto: `${publicImagesPath}/visual-sem-texto.webp`
}
